// The member's token goes with every call (api/common.js), so none is set here.
import { axios } from '@/api/common';

function handleResponse(response) {
	if (response.status === 200 || response.status === 204) {
		return {
			isError: false,
			data: response.data
		};
	}
}

function handleError(error) {
	return {
		isError: true,
		errorDecription: error.response.data.error_description
	};
}

export default {
	get(pathName, queryName, queryValue, optionalPath = '') {
		return axios
			.post(`/${pathName}/${optionalPath}`, null, {
				params: { [`${queryName}`]: queryValue }
			})
			.then((response) => handleResponse(response))
			.catch((error) => handleError(error));
	},
	getExcel_CircuitDevices(pathName, queryName, queryValue, fileName, langCode, optionalPath = '') {
		return axios
			.post(`/${pathName}/${optionalPath}`, null, {
				responseType: 'blob',
				params: { [`${queryName}`]: queryValue, langCode: langCode }
			})
			.then((response) => {
            const link = document.createElement('a');
				link.href = window.URL.createObjectURL(
					new Blob([response.data])
				);
				 link.setAttribute('download', fileName + '.xlsx');
				document.body.appendChild(link);
				link.click();
			})
			.catch((error) => handleError(error));
	},
	getExcel_Projects(pathName, queryName, queryValue, fileName, optionalPath = '') {
		return axios
			.post(`/${pathName}/${optionalPath}`, null, {
				responseType: 'blob',
				params: { [`${queryName}`]: queryValue }
			})
			.then((response) => {
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(
					new Blob([response.data])
				);
				link.setAttribute('download', fileName + '.xlsx');
				document.body.appendChild(link);
				link.click();
			})
			.catch((error) => handleError(error));
	},
	uploadExcel_CircuitDevices(pathName, payload, memberId, config, optionalPath = '') {
		return axios
			.post(`/${pathName}/Add${optionalPath}?memberId=${memberId}`, payload, {
				...config
			})
			.then((response) => handleResponse(response))
			.catch((error) => handleError(error));
	},
	// Admins only: the API reads the member from the token.
	uploadExcel_CircuitDevices_Admin(files, config) {
		return axios
			.post('/Panel/AddUploadExcel_CircuitDevices_Admin', { Files: files }, {
				...config
			})
			.then((response) => handleResponse(response))
			.catch((error) => handleError(error));
	},
	downloadMembers(fileName, optionalPath = '') {
		return axios
			.post(`/Panel/${optionalPath}`, null, {
				responseType: 'blob'
			})
			.then((response) => {
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(
					new Blob([response.data])
				);
				link.setAttribute('download', fileName + '.xlsx');
				document.body.appendChild(link);
				link.click();
			})
			.catch((error) => handleError(error));
	}
};
